export default "__VITE_ASSET__BIPctu9x__"